import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "connect-modal__header" }
const _hoisted_2 = { class: "connect-modal__header-content" }
const _hoisted_3 = { class: "connect-modal__icon-container" }
const _hoisted_4 = { class: "connect-modal__title-group" }
const _hoisted_5 = { class: "connect-modal__title" }
const _hoisted_6 = { class: "connect-modal__subtitle" }
const _hoisted_7 = { class: "connect-modal__body" }
const _hoisted_8 = { class: "connect-modal__features" }
const _hoisted_9 = { class: "connect-modal__features-list" }
const _hoisted_10 = { class: "connect-modal__features-column" }
const _hoisted_11 = { class: "connect-modal__features-column" }
const _hoisted_12 = {
  key: 0,
  class: "connect-modal__account-type"
}
const _hoisted_13 = ["disabled"]

import { computed, ref, watch } from "vue";
import { Icon } from "@iconify/vue";
import { Select } from "@/components/ui";
import type { Channel } from "@/dtos/Unipile.dto";
import type { SelectOption } from "@/components/ui/types";

interface Props {
  show: boolean;
  channel?: Channel | null;
  isLoading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectChannelModal',
  props: {
    show: { type: Boolean },
    channel: {},
    isLoading: { type: Boolean, default: false }
  },
  emits: ["close", "connect"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedAccountType = ref<string>("");
const showAccountTypeError = ref(false);

const accountTypeOptions: SelectOption[] = [
  { value: "GOOGLE", label: "Google" },
  { value: "OUTLOOK", label: "Microsoft Outlook" },
];

// Reset account type when modal closes or channel changes
watch(
  () => [props.show, props.channel?.type],
  () => {
    if (!props.show || props.channel?.type !== "email") {
      selectedAccountType.value = "";
      showAccountTypeError.value = false;
    }
  }
);

const channelName = computed(() => props.channel?.name || "Channel");
const channelIcon = computed(() => props.channel?.icon || "mdi:link-variant");

const channelFeatures = computed(() => {
  const channelType = props.channel?.type;
  if (channelType === "email") {
    return ["Messaging", "File Sharing", "Read Receipts", "Thread Management"];
  } else if (channelType === "linkedin") {
    return ["Messaging", "InMail", "Connection Requests", "Read Receipts"];
  }
  return ["Messaging", "File Sharing", "Voice Messages", "Read Receipts"];
});

const handleConnect = () => {
  if (!props.channel) return;

  // Validate account type for email
  if (props.channel.type === "email" && !selectedAccountType.value) {
    showAccountTypeError.value = true;
    return;
  }

  showAccountTypeError.value = false;
  emit("connect", props.channel, selectedAccountType.value || undefined);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal-fade" }, {
      default: _withCtx(() => [
        (__props.show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "connect-modal-overlay",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
            }, [
              _createElementVNode("div", {
                class: "connect-modal",
                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_unref(Icon), {
                        icon: channelIcon.value,
                        class: "connect-modal__icon"
                      }, null, 8, ["icon"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("h4", _hoisted_5, "Connect " + _toDisplayString(channelName.value), 1),
                      _createElementVNode("p", _hoisted_6, " Authenticate your " + _toDisplayString(channelName.value) + " account to start messaging through Unipile API. ", 1)
                    ])
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "connect-modal__close",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                  }, [
                    _createVNode(_unref(Icon), { icon: "mdi:close" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "connect-modal__features-title" }, "Features:", -1)),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channelFeatures.value.slice(0, 2), (feature) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: feature,
                            class: "connect-modal__feature-item"
                          }, [
                            _createVNode(_unref(Icon), {
                              icon: "mdi:check-circle",
                              class: "connect-modal__feature-check"
                            }),
                            _createElementVNode("span", null, _toDisplayString(feature), 1)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channelFeatures.value.slice(2), (feature) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: feature,
                            class: "connect-modal__feature-item"
                          }, [
                            _createVNode(_unref(Icon), {
                              icon: "mdi:check-circle",
                              class: "connect-modal__feature-check"
                            }),
                            _createElementVNode("span", null, _toDisplayString(feature), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  (__props.channel?.type === 'email')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_unref(Select), {
                          modelValue: selectedAccountType.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedAccountType).value = $event)),
                          label: "Account Type",
                          placeholder: "Select account type",
                          options: accountTypeOptions,
                          error: 
                  showAccountTypeError.value ? 'Account type is required for email channel' : undefined
                ,
                          required: ""
                        }, null, 8, ["modelValue", "error"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: _normalizeClass(["connect-modal__connect-btn", { 'connect-modal__connect-btn--loading': __props.isLoading }]),
                    onClick: handleConnect,
                    disabled: __props.isLoading || (__props.channel?.type === 'email' && !selectedAccountType.value)
                  }, [
                    (__props.isLoading)
                      ? (_openBlock(), _createBlock(_unref(Icon), {
                          key: 0,
                          icon: "mdi:loading",
                          class: "connect-modal__connect-icon connect-modal__connect-icon--spinning"
                        }))
                      : (_openBlock(), _createBlock(_unref(Icon), {
                          key: 1,
                          icon: "mdi:link-variant",
                          class: "connect-modal__connect-icon"
                        })),
                    _createTextVNode(" " + _toDisplayString(__props.isLoading ? "Connecting..." : `Connect ${channelName.value}`), 1)
                  ], 10, _hoisted_13),
                  _cache[5] || (_cache[5] = _createElementVNode("p", { class: "connect-modal__security-note" }, " Secured by Unipile API • Your credentials are encrypted. ", -1))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})